import React from 'react';
import PropTypes from 'prop-types';

import '../styles/QuestionMenu.css';
import MenuHeader from './MenuHeader';

const QuestionMenu = ({ title, question, name, parentName, subTitle, index}) => (
    <>
      <MenuHeader itemName={name} parentItemName={parentName} />
      <div className="Question-screen">
        {subTitle && 
          <div className="Question-subtitle">{subTitle}</div>}
        {title && 
          <div className="Question-title">{title}</div>}
        <div className="Question-question">{question}</div>
        <div className="Question-buttons-group">
          <div className={`Question-button ${index === 0 ? "Button-active" : ""}`}>Cancel</div>
          <div className={`Question-button ${index === 1 ? "Button-active" : ""}`}>OK</div>
        </div>
      </div>
    </>
);
  
QuestionMenu.propTypes = {
    itemName: PropTypes.string,
    parentName: PropTypes.string,
    title: PropTypes.string,
    question: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    index: PropTypes.number.isRequired,
};

export default QuestionMenu;